module.exports = __webpack_public_path__ + "static/media/d.5416d593.gif";